<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="queryFormRef" style="flex:1" :inline="true" :model="search" class="demo-form-inline"
                size="mini">
                <el-form-item label="型号：" prop="model_code">
                    <SearchInnerModel v-model="search.model_code" @selectQuery="Search"></SearchInnerModel>
                </el-form-item>
                <el-form-item label="设备uuid：" prop="uuid">
                    <el-input v-model.trim="search.uuid" placeholder=" " @keyup.enter.native="Search"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="账号">
                <template v-slot="scope">
                    <span>{{ scope.row.account }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备UUID" width="320">
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="型号">
                <template v-slot="scope">
                    <span>{{ scope.row.model }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备名称">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="序列号" width="200">
                <template v-slot="scope">
                    <span>{{ scope.row.sn }}</span>
                </template>
            </el-table-column>
            <el-table-column label="版本号" width="80">
                <template v-slot="scope">
                    <span>{{ scope.row.version }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Mac" width="140">
                <template v-slot="scope">
                    <span>{{ scope.row.mac }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180" prop="create_time" :formatter="(row) => row.create_time && util.dateFormat(row.create_time)
                ">
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total" background>
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">

import SearchInnerModel from '../../../components/device/SearchInnerModel.vue'
import util from '../../../util/util'

export default {
    name: 'onlinedevice',
    mixins: [],
    components: {
        SearchInnerModel
    },
    props: {},
    data() {
        return {
            util: util,
            search: {
                page: 1,
                limit: 16,
                model_code: '',
                uuid: ''
            },
            list: [],
            total: 0,
            title: '',
            edit: false,
            form: {
                id: '',
                product_model_code: '',
                uuid: '',
                uuid_secret: '',
                mac: '',
                sn: '',
                status: '',
                brand: '',
            },
            rules: {
                product_model_code: [{ required: true, message: '请输入产品型号编号', trigger: 'blur' }],
                uuid: [{ required: true, message: '请输入设备唯一编号', trigger: 'blur' }],
                uuid_secret: [{ required: true, message: '请输入设备秘钥', trigger: 'blur' }],
                mac: [{ required: true, message: '请输入出厂mac信息', trigger: 'blur' }],
                sn: [{ required: true, message: '请输入出厂sn信息', trigger: 'blur' }],
                status: [{ required: true, message: '请输入状态', trigger: 'blur' }],
                brand: [{ required: true, message: '请输入设备来源', trigger: 'blur' }],
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        handleCurrentChange(val) {
            this.search.page = val
            sessionStorage.setItem('currentPage', val)
            this.Search()
        },
        Search() {
            this.api.DanaList(this.search).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        Validate: function (call) {
            this.$refs['form'].validate(res => {
                if (res && call) {
                    call()
                }
            })
        },
        getSchoolWebModuleMessageListFunc() {
            setTimeout(() => {
                if (sessionStorage.getItem("currentPage") && sessionStorage.getItem("currentPage") !== 1) {
                    this.search.page = Number(sessionStorage.getItem("currentPage"))
                }
                this.Search()
            }, 0)
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        reset() {
            this.search = {
                ...this.search,
                model_code: '',
                uuid: ''
            }
        },
    },
    filters: {},
    mounted() {
        this.getSchoolWebModuleMessageListFunc()
    },
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
